module.exports = __webpack_public_path__ + "img/profil_lapper_Carla.86711e44.png";